/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Tea_StateInputs */

const vi_tea_purchase_tea_state = /** @type {(inputs: Tea_Purchase_Tea_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái chè`)
};

/**

* @param {Tea_Purchase_Tea_StateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_tea_state = /** @type {((inputs?: Tea_Purchase_Tea_StateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Tea_StateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_tea_state(inputs)
});